import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=70ce2e34&"
import script from "./TermsConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsConditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports